import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const CrystalGrowthAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<10; i++){
    const ang = (i/10)*Math.PI*2 + progress;
    const r = getRadiusAtAngle(ang, e, e.maxRadius);
    const cx = e.pos.x + Math.cos(ang) * r;
    const cy = e.pos.y + Math.sin(ang) * r;
    ctx.beginPath(); ctx.moveTo(cx, cy);
    ctx.lineTo(cx + 15 * (1-progress), cy - 30 * (1-progress));
    ctx.lineTo(cx + 30 * (1-progress), cy);
    ctx.closePath(); ctx.fill();
  }
};

registerBlastAnimation('CRYSTAL_GROWTH', CrystalGrowthAnimation);
